export const routes = [{
    path: '/configuracoes',
    component: () =>
        import( /* webpackChunkName: "tema" */ './components/List'),
    name: 'configuracoes.list',
    meta: {
        requiresAuth: true
    }
}]